$(window).load(function(){
    $('.slider-infobox').addClass('animated');
});